import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { type MouseEvent, useState } from 'react'

interface OptionsMenuProps {
	onDelete: () => void
}

export default function OptionsMenu({ onDelete }: OptionsMenuProps) {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

	const open = Boolean(anchorEl)

	const handleClick = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<div>
			<IconButton title='Opções' onClick={handleClick}>
				<MoreVertOutlinedIcon />
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				<MenuItem onClick={() => onDelete()}>Excluir</MenuItem>
			</Menu>
		</div>
	)
}
